var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
import { useSignIn, useSignOut } from 'react-auth-kit';
import { useNavigate, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Heading from '../../../components/Typography/Heading';
import Paragraph from '../../../components/Typography/Paragraph';
import FormWrapper from '../../../components/Form/Wrapper';
import FormRow from '../../../components/Form/Row';
import TextInput from '../../../components/Fields/TextInput';
import Button from '../../../components/Button';
import axiosInstance from '../../../config/axios';
import { api } from '../../../config/api';
import { RoutePaths } from '../../../config/routes';
import { Fields } from '../../../utils/Fields';
import StyledLink from '../../../components/Typography/StyledLink';
import ReassuranceWrapper from '../../../components/Reassurance/Wrapper';
import ReassuranceItem from '../../../components/Reassurance/Item';
import { Handshake, Sparkle } from '../../../components/CustomIcon';
import StepWrapper from '../../../components/Step/Wrapper';
import FormLayout from '../../../components/Step/FormLayout';
import { useValidation, ValidationString } from '../../../hooks/useValidation';
import FormGrid from '../../../components/Step/FormGrid';
import FormCol from '../../../components/Step/FormCol';
import LogoWhite from '../../../../../images/logo_white.svg';
import { motion } from 'framer-motion';
import FadeUp from '../../../components/Animation/FadeUp';
import jwtDecode from 'jwt-decode';
import { usePlaceholder } from '../../../hooks/usePlaceholder';
import Seo from '../../../components/Seo';
import { toast } from 'react-toastify';
var scaleUp = {
    initial: {
        scale: 0,
        x: '50%',
        y: '-50%',
    },
    visible: {
        scale: 1,
        x: '50%',
        y: '-50%',
        transition: {
            delay: 0.5,
        },
    },
    exit: {
        scale: 0,
        x: '50%',
        y: '-50%',
    },
};
var scaleUpBottom = {
    initial: {
        scale: 0,
    },
    visible: {
        scale: 1,
        transition: {
            delay: 0.5,
        },
    },
    exit: {
        scale: 0,
    },
};
var SignInForm = function () {
    var navigate = useNavigate();
    var state = useLocation().state;
    var signIn = useSignIn();
    var signOut = useSignOut();
    var textRequired = useValidation().textRequired;
    var placeholders = usePlaceholder();
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var schema = yup.object().shape({
        username: textRequired,
        password: textRequired,
    });
    var _b = useForm({
        resolver: yupResolver(schema),
    }), handleSubmit = _b.handleSubmit, control = _b.control, setError = _b.setError;
    var fields = [
        {
            type: Fields.TEXT,
            name: 'username',
            label: 'Identifiant',
            placeholder: placeholders.email,
            control: control,
            required: true,
        },
        {
            type: Fields.PASSWORD,
            name: 'password',
            label: 'Mot de passe',
            placeholder: placeholders.password,
            control: control,
            required: true,
        },
    ];
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var username, password, response, _a, token, user, isSignedIn, error_1, code;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    username = data.username, password = data.password;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axiosInstance.post(api.token.generate, { username: username, password: password })];
                case 2:
                    response = _b.sent();
                    _a = response.data, token = _a.token, user = _a.user;
                    isSignedIn = signIn({
                        token: token,
                        tokenType: 'Bearer',
                        expiresIn: jwtDecode(token).exp,
                        authState: user,
                    });
                    if (isSignedIn) {
                        setLoading(false);
                        navigate(RoutePaths.DASHBOARD);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    if (error_1.response) {
                        code = error_1.response.data.code;
                        switch (code) {
                            case '[jwt_auth] invalid_username':
                                setError('username', { message: ValidationString.INVALID_USERNAME });
                                break;
                            case '[jwt_auth] invalid_email':
                                setError('username', { message: ValidationString.INVALID_EMAIL });
                                break;
                            case '[jwt_auth] incorrect_password':
                                setError('password', { message: ValidationString.INVALID_PASSWORD });
                                break;
                            default:
                                toast.error(ValidationString.ADMIN_LOGIN, {
                                    autoClose: 5000,
                                });
                                break;
                        }
                        setLoading(false);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        signOut();
        if (state === null || state === void 0 ? void 0 : state.expiredSession) {
            toast.error(ValidationString.EXPIRED_SESSION, {
                autoClose: 5000,
            });
        }
    }, []);
    return (<>
      <Seo title="Se connecter"/>
      <StepWrapper>
        <FormLayout>
          <div className="relative w-full overflow-hidden bg-secondary-01-light pt-16 pb-10 lg:hidden">
            <motion.div className="absolute top-0 right-0 h-[21rem] w-[21rem] origin-center -translate-y-1/2 translate-x-1/2 rounded-full bg-secondary-01" variants={scaleUp} initial="initial" animate="visible" exit="exit"/>
            <div className="container relative z-10">
              <div className="dark mx-auto flex max-w-[480px] flex-col items-center">
                <a href="/" aria-label="Navigation vers la page d'accueil">
                  <img src={LogoWhite} alt="Logo de Majeures" width={166} height={33}/>
                </a>
                <Paragraph size="lg" className="mt-6 text-center">
                  L’annuaire des professionnel·les femmes, personnes trans et non-binaires de la
                  musique
                </Paragraph>
              </div>
            </div>
          </div>
          <motion.div className="fixed bottom-0 left-0 -z-1 h-[16rem] w-[16rem] origin-bottom-left rounded-tr-full bg-secondary-02 max-lg:hidden" variants={scaleUpBottom} initial="initial" animate="visible" exit="exit"/>
          <FormGrid>
            <FormCol className="my-6 sm:my-10 lg:my-28">
              <Heading level={1} type="h4">
                Votre compte
              </Heading>
              <div className="space-y-4">
                <Paragraph size="sm">
                  Connectez-vous pour retrouver vos informations personnelles et gérez votre profil.
                </Paragraph>
                <Paragraph size="sm">
                  Pas encore sur Majeur·e·s ?{' '}
                  <StyledLink size="sm" to={RoutePaths.SIGN_IN_SITUATION}>
                    Inscrivez-vous !
                  </StyledLink>
                </Paragraph>
              </div>

              <form onSubmit={handleSubmit(onSubmit)} className="mt-6 md:mt-8">
                <FormWrapper>
                  {fields.map(function (field) {
            return (<FormRow key={field.name}>
                        <TextInput {...field}/>
                      </FormRow>);
        })}
                  <StyledLink to={RoutePaths.PASSWORD_FORGOT} size="xs">
                    Mot de passe oublié ?
                  </StyledLink>
                  <Button submit loading={loading} className="mt-6 sm:self-start md:mt-9">
                    Se connecter
                  </Button>
                </FormWrapper>
              </form>
            </FormCol>
          </FormGrid>
        </FormLayout>
        <ReassuranceWrapper>
          <FadeUp>
            <Paragraph size="lg" className="lg:mb-4 2xl:mb-8">
              L’annuaire des professionnel·les femmes, personnes trans et non-binaires de la musique
            </Paragraph>
          </FadeUp>
          <ReassuranceItem icon={Handshake}>
            <Heading level={6}>Rejoignez la communauté</Heading>
            <Paragraph size="sm" className="mt-2">
              Complétez votre profil pour{' '}
              <span className="font-bold">être référencé·e sur Majeur·e·s.</span> Que votre carrière
              débute ou non, vous êtes déjà au coeur de l'industrie&nbsp;!
            </Paragraph>
          </ReassuranceItem>
          <ReassuranceItem icon={Sparkle} className="mt-10">
            <Heading level={6}>Trouvez des profils inspirants</Heading>
            <Paragraph size="sm" className="mt-2">
              Connectez-vous pour{' '}
              <span className="font-bold">accéder aux informations de contact</span> de l’ensemble
              des professionnel·les référencé·es sur l’annuaire.
            </Paragraph>
          </ReassuranceItem>
        </ReassuranceWrapper>
      </StepWrapper>
    </>);
};
export default SignInForm;
